import { NumberWithUnitsFormatter } from '@ddt-web/data-service';
import { StringUtil } from '@ddt-web/generic-utils';

/**
 * DecumSavingsChartTooltip: For the Portflio chart which appears on the click of view timeline button on the decum results page
 */
export class DecumSavingsChartTooltip {
	public static getFormatter(customData: CustomData, displayCurrency: string = '$'): Function {
		const formatter = new NumberWithUnitsFormatter('0', '-', true);
		return function (): string {
			let out = '';
			let setTooltipHeader = true;
			let setTooltipFooter = true;
			const tooltipHeader = customData.headerText;
			const tooltipFooter = customData.footerText;
			out += '<div class="decum-histogram-tooltip-container">';
			this?.points?.forEach((point, index) => {
				const estPortfolioValue = customData.estPortfolioValue.find(item => item[0] === point.x)[1];
				if (setTooltipHeader) {
					out += `<h4><span class="bold">${tooltipHeader}</span> ${point.x}</h4>
								
								<div class="border-bottom"></div>`;
					setTooltipHeader = false;
				}
				out += `<div class="decum-histogram-tooltip"><table>
						<tr>
						<span class="custom-width"><td colspan="2" style="width:75%;">
						${StringUtil.splitSpaceLessStringForChart(point.point.series.name, 50, true)}
						</td>
						</span>
						<td style="text-align: right">
						${displayCurrency}${index === 0 ? formatter.format(Number(point.total)) : index === 1 ? formatter.format(Number(estPortfolioValue)) : formatter.format(Number(point.y))}
						</td>
						</tr>
					</table></div>`;
			});

			this?.points?.forEach(point => {
				if (setTooltipFooter) {
					const currbalanceSaving = point.total - point.y;
					const currCoriValue = customData.coriValues[point.x - customData.minIndex].valueOf();
					const annuityIncome = currbalanceSaving / currCoriValue;
					out += `<div class="border-bottom"></div>
						<h4 class="custom-margin"><span class="bold">${tooltipFooter}</span> ${displayCurrency}${formatter.format(Number(annuityIncome))}</h4>
						`;
					setTooltipFooter = false;
				}
			});
			out += '</div>';
			return out;
		};
	}
}

export interface CustomData {
	coriValues?: Array<number>;
	minIndex?: number;
	estPortfolioValue?: Array<[number, number]>;
	headerText?: string;
	footerText?: string;
}
